import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CircleAlert, FlaskConical, Moon, Sun } from 'lucide-react';
import { api } from '../api';
import { useSesion } from '../state/Sesion';
import { useTema } from '../state/Tema';

export function LoginPagina() {
  const { usuario, login } = useSesion();
  const { tema, alternar } = useTema();
  const navegar = useNavigate();
  const ubicacion = useLocation();
  const [email, setEmail] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const destino = (ubicacion.state as { desde?: string } | null)?.desde ?? '/';

  if (usuario) return <Navigate to={destino} replace />;

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !contrasena) {
      setError('Ingresá tu email y tu contraseña.');
      return;
    }
    setEnviando(true);
    setError(null);
    try {
      await login(email.trim(), contrasena);
      navegar(destino, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión.');
    } finally {
      setEnviando(false);
    }
  };

  const etiquetaTema = `Cambiar a tema ${tema === 'dark' ? 'claro' : 'oscuro'}`;
  return (
    <div className="login-wrap">
      <button type="button" className="icon login-top" onClick={alternar} title={etiquetaTema} aria-label={etiquetaTema}>
        {tema === 'dark' ? <Sun aria-hidden /> : <Moon aria-hidden />}
      </button>
      <form className="login" onSubmit={enviar} noValidate>
        <div className="brand">
          <span className="brand-mark">A</span>AUSTRA<span className="brand-sub">TRANSPORT MANAGEMENT</span>
        </div>
        <h1 style={{ fontSize: 22 }}>Torre de control</h1>
        <p className="muted" style={{ marginTop: 6 }}>
          Ingresá con tu cuenta del TMS.
        </p>
        <label htmlFor="email">Email</label>
        <input id="email" type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        <label htmlFor="clave">Contraseña</label>
        <input id="clave" type="password" autoComplete="current-password" value={contrasena} onChange={(e) => setContrasena(e.target.value)} />
        {error && (
          <p className="error-msg" role="alert">
            <CircleAlert aria-hidden size={16} />
            {error}
          </p>
        )}
        <button className="primary" type="submit" disabled={enviando}>
          {enviando ? 'Ingresando…' : 'Ingresar'}
        </button>
        {api.esMock && (
          <p className="aviso-demo">
            <FlaskConical aria-hidden />
            <span>Modo demostración · datos ficticios. Entrás con cualquier email y contraseña.</span>
          </p>
        )}
      </form>
    </div>
  );
}
